import { useBreak }   from 'hooks/useBreak'
import { NavMobile }  from './Nav.Mobile'
import { NavDesktop } from './Nav.Desktop'
import { isIframeMode } from 'logging/logging'

export const Nav = () => {
  const iFrameEnabled = isIframeMode()
  return useBreak('md_dn') 
    ? (!iFrameEnabled ?
      <NavMobile/> :
      <></>
    ) : ( 
      // <NavDesktop/>
      <></>
    )
    
}